<app-generic-side-modal-container [sideNavTitleText]="'Services category' | translate">    
  <div mainPageContent class="overflow-clip padding_20 w-full">
    <div>
      <app-data-grid [dataGridSettings]="dataGridSettings"></app-data-grid>
    </div>
  </div>

  <div sideNavContent class="w-full px-[1rem]">        
          <mat-card style="margin-top: 1.5rem" *ngFor="let serviceCategory of serviceCategoryData">
            <mat-card-content>
              <div class="flex flex-row justify-between w-full gap-3 items-center">
                <div class="uppercase font-semibold text-base md:text-lg lg:text-xl">{{serviceCategory.name}}</div>
                <div class="flex flex-row justify-end gap-5">
                  <i class="fa-regular fa-pen-to-square text-[1.7rem] hover:cursor-pointer"
                      (click)="toggleEditServicePopup(true, serviceCategory.id!)"></i>
                </div>
              </div>

            </mat-card-content>
          </mat-card>

          <div class="w-full flex flex-col justify-center align-middle">
            <button class="bg-secondary px-10 py-4 rounded-xl flex justify-center mb-4 mt-12 align-middle self-center" (click)="toggleAddServicePopup()">
              <div class="flex gap-4">
                <img src="/assets/image/add.svg" class="h-9">
                <div class="uppercase text-white">
                  {{"New category" | translate}}
                </div>
              </div>
            </button>
          </div>

  </div>

</app-generic-side-modal-container>

<app-generic-modal *ngIf="addServiceCategoryPopupState" [bannerText]="'Add service category' | translate " [handle_extreme_overflow]="false"
  [handle_mobile]="true" (handleCloseEmitter)="closePopup()">
  <app-service-category-popup (close)="closePopup()"></app-service-category-popup>
</app-generic-modal>

<app-generic-modal *ngIf="editServiceCategoryPopupState" [bannerText]="'Edit service category' | translate " [handle_extreme_overflow]="false"
  [handle_mobile]="true" (handleCloseEmitter)="closePopup()">
  <app-service-category-popup (close)="closePopup()" [serviceCategoryId]="serviceCategoryId"></app-service-category-popup>
</app-generic-modal>


